import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { MatSelect } from "@angular/material/select";
import { ConnectedPosition } from "@angular/cdk/overlay";

const USABLE_VIEWPORT_BOTTOM_RESERVE_PX = 100;

const MIN_SPACE_BELOW_TO_KEEP_DOWN_FIRST_PX = 72;

@Directive({
  selector: "mat-select",
})
export class MatSelectPreferOpenUpwardDirective
  implements AfterViewInit, OnDestroy
{
  private positionsDefault: [ConnectedPosition, ConnectedPosition] | null =
    null;
  private originalOpen: (() => void) | null = null;

  private baselineDisableOptionCentering = false;

  constructor(
    private matSelect: MatSelect,
    private hostRef: ElementRef<HTMLElement>
  ) {}

  ngAfterViewInit(): void {
    const host = this.matSelect as unknown as {
      _positions?: ConnectedPosition[];
      open: () => void;
    };
    const positions = host._positions;
    if (!positions || positions.length !== 2) {
      return;
    }
    this.positionsDefault = [positions[0], positions[1]];
    this.baselineDisableOptionCentering = !!this.matSelect.disableOptionCentering;

    this.originalOpen = host.open.bind(host);
    host.open = () => {
      const preferUp = this.shouldPreferOpeningUpward();
      
      this.matSelect.disableOptionCentering = preferUp
        ? true
        : this.baselineDisableOptionCentering;

      if (preferUp) {
        host._positions = [this.positionsDefault![1], this.positionsDefault![0]];
      } else {
        host._positions = [this.positionsDefault![0], this.positionsDefault![1]];
      }
      this.originalOpen!();
    };
  }

  ngOnDestroy(): void {
    const host = this.matSelect as unknown as { open: () => void };
    if (this.originalOpen) {
      host.open = this.originalOpen;
    }
  }

  private getTriggerViewportRect(): DOMRect {
    const root = this.hostRef.nativeElement;
    const trigger = root.querySelector<HTMLElement>(".mat-select-trigger");
    return (trigger ?? root).getBoundingClientRect();
  }

  private shouldPreferOpeningUpward(): boolean {
    if (typeof window === "undefined") {
      return false;
    }
    const rect = this.getTriggerViewportRect();
    const usableBottom = window.innerHeight - USABLE_VIEWPORT_BOTTOM_RESERVE_PX;
    const spaceBelow = usableBottom - rect.bottom;
    return spaceBelow < MIN_SPACE_BELOW_TO_KEEP_DOWN_FIRST_PX;
  }
}
